/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-danger */
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import { Star } from "@mui/icons-material";
import { Typography, Avatar, useTheme } from "@mui/material";
import axios from "axios";
import moment from "moment";
import ReactPlayer from "react-player";

import MessageActions from "./MessageActions";
import { isMessageHasArabic } from "../helper";
import useStyles from "./style.js";
import { showPhotoModal } from "../../../../redux/styles/actions";
import updateLinkDetails from "../../../../redux/messages/thunks/updateLinkDetails";
import DocFileIcon from "../../../../assets/icons/DocFileIcon.js";
import ForwardIcon from "../../../../assets/icons/ForwardIcon.js";

const MessageItem = ({
  body,
  id,
  campaign_id,
  from,
  conversationType,
  status,
  displayStatus,
  date,
  displayDate,
  type,
  handleForwardMessages,
  selected,
  starred_by,
  forwarded_by,
  handleMessageInfo,
  handleNavigateMessage,
  starredMessage,
  caption,
  showNewMessagesLine,
  isMessageInfo,
  isNew,
  addLink,
}) => {
  const linkRef = useRef();
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const {
    userInfo: { _id, first_name, last_name, token },
  } = useSelector((state) => state.user);
  const [showNewMessagesLineState, setShowNewMessagesLine] = useState(showNewMessagesLine);
  const [showStatus, setShowStatus] = useState(false);
  const [starredByState, setStarredByState] = useState(starred_by);
  const [isMessageStarred, setIsMessageStarred] = useState(
    starredByState && starredByState.find((userId) => userId === _id),
  );
  const { t } = useTranslation();
  let infoMessage = "";
  let oldInner = "";
  let newInner = "";

  function UnsafeComponent({ html }) {
    return (
      <span
        className={classes.safeHtml}
        dangerouslySetInnerHTML={{ __html: html.split("\n").join("</br>") }}
      />
    );
  }

  function starMessageInChat(star) {
    const updatedStar =
      star === true ? starred_by.concat(_id) : starred_by.filter((user) => user._id !== _id);
    setStarredByState(updatedStar);
    setIsMessageStarred(star);
  }

  const handleStarMessage = async () => {
    await axios.patch(
      `/api/v1/messages/${id}?star=${isMessageStarred ? "false" : "true"}`,
      {},
      {
        headers: {
          Authorization: token,
        },
      },
    );
    starMessageInChat(!isMessageStarred);
  };

  // This is the function we wrote earlier
  const copyTextToClipboard = async () => {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(body);
    } else {
      return document.execCommand("copy", true, body);
    }
  };

  useEffect(() => {
    if (isNew) {
      const ele = document.getElementById("newMessageLine");
      if (ele) {
        ele.style.visibility = "hidden";
        setShowNewMessagesLine(false);
      }
    }
  }, [isNew]);

  if (type === "info" && from && from[0]) {
    if (from[0]._id === _id || from === _id) infoMessage = "You".concat(body);
    else {
      infoMessage = `${from[0].first_name} ${from[0].last_name}`.concat(body);
    }
  }

  const handleLinkClick = () => dispatch(updateLinkDetails(id, undefined, campaign_id, token));

  // To detect URL and in message with type='link' and make it clickable
  useEffect(() => {
    if (linkRef && linkRef.current) {
      const stringLinkTpReplace = linkRef.current.innerHTML.match(
        /(http(s)?:\/\/.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
      );
      stringLinkTpReplace &&
        stringLinkTpReplace.forEach((link) => {
          // Add 'http://' to the link if it doesn't start with 'http://' or 'https://'
          const modifiedLink =
            link.startsWith("http://") || link.startsWith("https://") ? link : "http://" + link;

          oldInner = linkRef.current.innerHTML;
          newInner = oldInner.replace(
            link,
            `<a target="_blank" rel="noreferrer" href="${modifiedLink}">${modifiedLink}</a>`,
          );
          linkRef.current.innerHTML = newInner;
        });
      linkRef.current.onclick = handleLinkClick;
    }
  }, []);

  return (
    <>
      {/* Messages Date */}
      {displayDate && type !== "info" ? (
        moment(date).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD") ? (
          <p className={classes.date}>{`${t("today")} ${moment(new Date(date)).format(
            "h:mm A",
          )}`}</p>
        ) : moment(date).format("YYYY-MM-DD") ===
          moment().subtract(1, "days").format("YYYY-MM-DD") ? (
          <p className={classes.date}>{t("yesterday")}</p>
        ) : (
          <p className={classes.date}>{new Date(date).toDateString()}</p>
        )
      ) : null}

      {/* New message line */}
      {showNewMessagesLineState ? (
        <div className={classes.newMessagesTextContainer} id="newMessageLine">
          <div className={classes.newMessagesText}>NEW MESSAGES</div>
          <div className={classes.line} />
        </div>
      ) : null}

      <li
        style={{
          opacity: !id ? 0.6 : "none",
          listStyleType: "none",
          margin: starredMessage === true ? 0 : "5px 5%",
          // position: "relative",
          display: "flex",
          borderRadius: "5px",
          justifyContent: starredMessage ? "start" : from[0]._id === _id ? "end" : "unset", // This line control the direction👌
        }}
        // className={classnames(selected === true ? classes.colorAnimation : "")}
        onClick={() => setShowStatus(!showStatus)}
      >
        {/* if info message */}
        {type === "info" && <p className={classes.messageInfo}>{infoMessage}</p>}

        {/* User avatar in group chat */}
        {conversationType === "group" ? (
          from[0]._id !== _id && !displayGroupUserAvatar ? (
            <div
              className={classes.avatar}
              style={{
                alignSelf: "end",
                display: "flex",
                alignItems: "flex-end",
              }}
            >
              <Avatar
                src={from[0].avatar_url || null}
                style={{
                  width: "40px",
                  height: "40px",
                  display: "block",
                  alignSelf: "flex-end",
                }}
              >
                {from[0].avatar_url ? null : `${from[0].first_name}${from[0].last_name}`}
              </Avatar>
            </div>
          ) : (
            <div
              style={{
                backgroundColor: "transparent",
                display: "block",
                width: "40px",
                height: "40px",
              }}
              className={classes.avatar}
            />
          )
        ) : null}

        {/* Message item and Message-sender-name in group chat */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: from[0]._id === _id ? "end" : "unset",
            alignSelf: from[0]._id === _id ? "end" : "unset",
          }}
        >
          {/* Message-sender-name in group chat */}
          {conversationType === "group" &&
            type !== "info" &&
            !displayGroupUserName &&
            String(from[0]._id) !== String(_id) && (
              <p className={classes.groupMessageSender}>{from[0].first_name}</p>
            )}

          {/* Normal message */}
          {type !== "info" && type !== undefined && type !== "poll" && (
            <>
              <div
                style={{
                  backgroundColor: theme.palette.bg,
                }}
                className={classnames(
                  selected === true ? classes.colorAnimation : "",
                  classes.messageItem,
                  starredMessage === true ? classes.blockDisplay : classes.flexDisplay,
                )}
              >
                {forwarded_by ? (
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      bottom: "-2px",
                      right: "3px",
                      alignSelf:
                        (from && from[0] && from[0]._id === _id) || from === _id ? "end" : "unset",
                    }}
                    className={classes.forwardedDiv}
                  >
                    <span className={classes.forwardedLabel}>
                      <ForwardIcon /> Forwarded
                    </span>
                  </div>
                ) : null}

                <div
                  className={classnames(
                    from && from[0] && from[0]._id === _id
                      ? starredMessage === true
                        ? `${classes.customerMessageBody} ${classes.customerMessageBodyGreenColor}`
                        : isMessageInfo === true
                          ? `${classes.userMessageBody} ${classes.greenBackground}`
                          : `${classes.userMessageBody}`
                      : `${classes.customerMessageBody}`,
                    classes.messageContent,
                  )}
                  style={{
                    display:
                      from && from[0] && from[0]._id !== _id
                        ? isMessageHasArabic(body)
                          ? "block"
                          : "flex"
                        : !isMessageHasArabic(body)
                          ? "flex"
                          : "unset",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column", maxWidth: "450px" }}>
                    <div className={classes.body} style={{ position: "relative" }}>
                      {type === "text" ? (
                        <UnsafeComponent html={body} />
                      ) : type === "doc" ? (
                        <a target="blank" href={body}>
                          <span className={classes.docFile}>
                            <DocFileIcon />
                            {body.split("/").slice(-1)[0]}
                          </span>
                        </a>
                      ) : type === "photo" ? (
                        <span onClick={() => dispatch(showPhotoModal(true, body))}>
                          <img className={classes.media} src={body} alt={body} />
                          <Typography>{caption}</Typography>
                        </span>
                      ) : type === "video" ? (
                        <span onClick={() => dispatch(showPhotoModal(true, body))}>
                          <ReactPlayer
                            url={body}
                            controls={true}
                            key="video"
                            width="100%"
                            height="200"
                            className={classes.media}
                          />
                        </span>
                      ) : type === "link" ? (
                        <span ref={linkRef}>{body}</span>
                      ) : null}

                      {!starredMessage && (
                        <MessageActions
                          className={classes.showMoreOptions}
                          messageId={id}
                          isMessageStarred={isMessageStarred}
                          handleForwardMessages={handleForwardMessages}
                          handleMessageInfo={handleMessageInfo}
                          showMessageInfo={from && from[0] && from[0]._id === _id}
                          handleStarMessage={handleStarMessage}
                          copyTextToClipboard={copyTextToClipboard}
                          from={from[0]._id}
                          hideShadow={type === "photo"}
                        />
                      )}
                      <Typography>{caption}</Typography>
                      {addLink ? <Typography>Add Link: {addLink}</Typography> : null}
                    </div>

                    <div
                      className={classes.time}
                      style={{
                        display: isMessageHasArabic(body) ? "block" : "inline",
                        color: from && from[0] && from[0]._id === _id ? "white" : "#8A8A8E",
                      }}
                    >
                      {isMessageStarred ? (
                        <Star
                          style={{
                            color: "#F9DA5B",
                            fontSize: "14px",
                            marginRight: "5px",
                            verticalAlign: "middle",
                          }}
                        />
                      ) : null}
                      {moment(new Date(date)).format("h:mm A")}
                    </div>
                  </div>
                </div>
              </div>

              {displayStatus && (
                <span
                  style={{
                    float: from[0]._id === _id || from === _id ? `right` : `left`,
                  }}
                  className={classes.status}
                >
                  {status}
                </span>
              )}
            </>
          )}
        </div>
      </li>
    </>
  );
};

export default MessageItem;
